var map = {
	"./frontend/AndroidGuide.vue": 3110,
	"./frontend/Banking.vue": 5090,
	"./frontend/BetslipHistory.vue": 2163,
	"./frontend/BodyFB.vue": 2857,
	"./frontend/Commission.vue": 9349,
	"./frontend/ContactUs.vue": 1481,
	"./frontend/DataTable.vue": 818,
	"./frontend/Deposit.vue": 3980,
	"./frontend/History.vue": 524,
	"./frontend/Home.vue": 5642,
	"./frontend/IOSGuide.vue": 9210,
	"./frontend/Iframe copy.vue": 3020,
	"./frontend/Iframe.vue": 1525,
	"./frontend/Index.vue": 729,
	"./frontend/Live.vue": 6804,
	"./frontend/LiveScore.vue": 5634,
	"./frontend/MainMenu.vue": 4694,
	"./frontend/MaungFB.vue": 8034,
	"./frontend/Promotion.vue": 6315,
	"./frontend/Promotions.vue": 2080,
	"./frontend/Setting.vue": 7423,
	"./frontend/VideoLink.vue": 1601,
	"./frontend/VipLevels.vue": 2180,
	"./frontend/Withdraw.vue": 7233,
	"./frontend/auth/Login.vue": 7417,
	"./frontend/auth/PhoneRegister.vue": 2450,
	"./frontend/auth/Register.vue": 2281,
	"./frontend/auth/Rule.vue": 2251,
	"./frontend/auth/Verify.vue": 4184,
	"./frontend/auth/VerifyNotAuth.vue": 2739,
	"./frontend/components/AccountSelect.vue": 3497,
	"./frontend/components/BackToTop.vue": 9034,
	"./frontend/components/DataTable.vue": 8247,
	"./frontend/components/FBPreviewVoucher.vue": 5049,
	"./frontend/components/FBVoucher.vue": 4528,
	"./frontend/components/FootballTeamCard.vue": 1430,
	"./frontend/components/GameCard.vue": 7188,
	"./frontend/components/GameCardSkeleton.vue": 1578,
	"./frontend/components/GroupBox.vue": 6533,
	"./frontend/components/InputSelectDrawModal.vue": 7306,
	"./frontend/components/LuckyWheel.vue": 4223,
	"./frontend/components/NormalBox.vue": 6251,
	"./frontend/components/PreviewVoucher.vue": 1552,
	"./frontend/components/SideNav.vue": 1604,
	"./frontend/components/SkeletonImage.vue": 8853,
	"./frontend/components/Table.vue": 7824,
	"./frontend/components/ThreedGroupBox.vue": 5327,
	"./frontend/components/TwoDSelect.vue": 8796,
	"./frontend/components/Voucher.vue": 7607,
	"./frontend/normal-user/2d/2d.vue": 6325,
	"./frontend/normal-user/2d/ClosedDays.vue": 7053,
	"./frontend/normal-user/2d/Home.vue": 188,
	"./frontend/normal-user/2d/Winner.vue": 4065,
	"./frontend/normal-user/3d/3d.vue": 1625,
	"./frontend/normal-user/3d/Home.vue": 2972,
	"./frontend/normal-user/DreamBooks.vue": 6547,
	"./frontend/normal-user/Index.vue": 5531,
	"./frontend/normal-user/bugyee/Room.vue": 9666,
	"./frontend/normal-user/game/Arcade.vue": 7800,
	"./frontend/normal-user/game/Fishing.vue": 2523,
	"./frontend/normal-user/game/Game.vue": 9621,
	"./frontend/normal-user/game/Slot.vue": 5954,
	"./frontend/normal-user/shankomee/Room.vue": 4199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7057;